import React from "react"
import { SEO } from "shared/components"
import styled from "styled-components"
import { Divider, IconCanada, Layout, ResponsiveContentImage, Title1, Title2, Title3VariableTextSize, Wrapper } from "../components"
import { PageHero } from "../components/page_hero"
import heroImage from "../images/a-front-view-of-woman-having-breakfast-in-bed-in-YXTU5LD.jpg"
import manSleeping from "../images/attractive-young-man-sleeping-K82XZEM.jpg"
import ourTeam from "../images/business-team-with-hands-on-top-at-office-PTCEYXU.jpg"
import mattress4 from "../images/mattress-4.jpg"
import womanWithPhone from "../images/smiling-woman-relaxing-with-phone-in-bed-P6Z83NV.jpg"
import { BLACK_COLOR, PRIMARY_COLOR_100, WHITE_COLOR } from "../styles"


const StyledImage = styled.div`
  background-image: radial-gradient(transparent, ${ WHITE_COLOR }), url( ${ manSleeping } );
  background-position-x: 55%;
  background-position-y: 50%;
  background-size: cover;
  height: 50vh;
  overflow: hidden;
  position: relative;
  width: 100%;
`

const About = () => (
  <Layout>
    <SEO title="Cuzy | About Us" description="About Cuzy" />
    <PageHero
      backgroundImage={ heroImage }
      positionY="70%"
      // tslint:disable-next-line: jsx-no-lambda
      renderContent={ () => (
        <div className="flex flex-col items-center pt-20">
          <Title1 className="text-center mb-5">About Us</Title1>
          <Title3VariableTextSize textSize="1.5rem" className="text-primary-100 font-bold text-center">We believe in providing a simple and convenient shopping experience, made accessible for everyone.</Title3VariableTextSize>
        </div>
      ) }
    />
    <section>
      <Wrapper className="flex flex-col items-center pt-20">
        <IconCanada className="mb-5"/>
        <Divider color={ PRIMARY_COLOR_100 } className="mb-5"/>
        <Title2 className="mb-5 text-primary-100">Our Mission</Title2>
        <p className="text-center mb-10">At CUZY our mission is to consistently deliver the most comfortable and enjoyable sleep experience. An overall experience that demonstrates outstanding value for our customers. We will provide superior service to our Canadian consumers and always strive to deliver the best sleep experience in terms of comfort, luxury & support.</p>
        <StyledImage />
      </Wrapper>
    </section>
    <ResponsiveContentImage
      image={ womanWithPhone }
      themeColor={ PRIMARY_COLOR_100 }
      title="Our Approach"
      content="Our approach is simple: offer the highest quality possible, in terms of design, materials and service that results in real consumer value and satisfaction. We have taken our 15 years of experience in the mattress industry and fine tuned to perfection a product that will revolutionize your sleep experience. A key element in driving value for our customers is our supportive &amp; luxurious design that delivers the essential support necessary for lasting comfort."
      imageOn="left"
      button={ {
        text: "Buy Now",
        url: "/products"
      } }
    />
    <ResponsiveContentImage
      image={ mattress4 }
      themeColor={ BLACK_COLOR }
      title="Sleep Experience"
      content="A great sleep experience starts with a great mattress. A complete sleep system that delivers total comfort must include comfortable bedding & pillows, but most importantly a mattress built for perfection. CUZY is built on the promise of comfortable sleeping and providing a lazy sleep experience that you’ll look forward to. We have an extended product line which complements high quality luxury mattresses with a full selection of high quality quilts, bedding and pillows. A great mattress provides outstanding long-term health benefits and complete comfort."
      imageOn="right"
      button={ {
        text: "Buy Now",
        url: "/products"
      } }
    />
    <ResponsiveContentImage
      image={ ourTeam }
      themeColor={ PRIMARY_COLOR_100 }
      title="Our Team"
      content="Successful deployment of our products requires dedicated and well-trained employees, as well as established Canadian based suppliers. At CUZY our management team is committed to building a great quality team of employees, suppliers and management, all working to deliver on our overall promise to our customers. The CUZY promise is to work together to fulfill our mission to consistently deliver the most comfortable sleep experience possible; at an outstanding value for our customers."
      imageOn="left"
    />
  </Layout>
)

export default About
